import currencyReducer from "./currencyReducer";
import cartReducer from "./cartReducer";
import wishlistReducer from "./wishlistReducer";
import compareReducer from "./compareReducer";
import siteReducer from "./siteReducer";
import rootPageReducer from "./rootPageReducer";
import dynamicPagesReducer from "./dynamicPagesReducer";
import brandReducer from "./brandReducer";
import { combineReducers } from "redux";
import { createMultilanguageReducer } from "redux-multilanguage";

const rootReducer = combineReducers({
    multilanguage: createMultilanguageReducer({ currentLanguageCode: "en" }),
    currencyData: currencyReducer,
    cartData: cartReducer,
    wishlistData: wishlistReducer,
    compareData: compareReducer,
    siteData: siteReducer,
    rootPageData: rootPageReducer,
    brandData: brandReducer,
    dynamicPagesData: dynamicPagesReducer,
});

export default rootReducer;
